/**
 * @file index.tsx
 *
 * @fileoverview Shows a job type selection for the widget.
 */

import React, { useContext } from 'react';
import Router from 'next/router';
import { JobWizardFlow } from '~/jobiqo/components/Job/Wizard/config';
import { PathContextInterface } from '~/jobiqo/models/app';
import { PathContext } from '~/jobiqo/context/app';
import JobWizardStepTypeView from '~/jobiqo/components/Job/Wizard/Steps/AddJobType/view';
import { useRuntimeStepsInfo } from '~/jobiqo/components/Job/Wizard/hooks/useRuntimeStepsInfo';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

interface JobWizardStepTypeProps {
  allowedJobTypes?: string[];
}
export const JobWizardStepType = ({
  allowedJobTypes,
}: JobWizardStepTypeProps) => {
  const pathContext: PathContextInterface = useContext(PathContext);
  const { JOBS } = useFrontendConfig();
  const ALLOWED_JOB_TYPES = JOBS.ALLOWED_JOB_TYPES;
  const resolvedAllowedJobTypes = allowedJobTypes ?? ALLOWED_JOB_TYPES;
  const { stepsInfo } = useRuntimeStepsInfo(JobWizardFlow.New);

  // We do not need the wizard steps here
  // we just directly push to the next step on clicking on job type
  // Check if the current step is the last based on path.
  const currentStep = stepsInfo.findIndex(
    (step) => step.page === pathContext.pathname,
  );

  return (
    <JobWizardStepTypeView
      allowedJobTypes={resolvedAllowedJobTypes}
      availableJobTypes={ALLOWED_JOB_TYPES}
      onChoose={(jobType) => {
        // Go to next page and pass as prop the job type.
        Router.push({
          pathname: stepsInfo[currentStep + 1].page,
          query: {
            jobType,
            ...pathContext.querystring,
          },
        });
      }}
    />
  );
};
export default JobWizardStepType;
